const calculateAccuracy = (actual, expected) => {
    const min = Math.min(actual, expected);
    const max = Math.max(actual, expected);
    const accuracy = 100 * (min / max);
    return accuracy;
};

export default calculateAccuracy;
